module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/design/line-4a55bcfa832d2d0b6ee3c01695d81b38.svg";